import { library, dom } from '@fortawesome/fontawesome-svg-core';

import { faWindows, faApple } from '@fortawesome/free-brands-svg-icons';
import {
	faBars,
	faSignOut,
	faPlus,
	faArrowLeft,
	faArrowRight,
	faSearch,
	faCalendarAlt,
	faClone,
	faEllipsisH,
	faCheckCircle,
	faExclamationCircle,
	faSpinner,
	faCommentAltDots,
	faLongArrowRight,
	faTrashAlt,
	faPrint,
	faUsersGear,
	faFileInvoice,
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faAngleDown,
	faCopy,
	faUpload,
	faHistory,
	faComment,
	faEdit,
	faEye,
	faTimes,
	faPenToSquare,
	faCalendarDays,
	faList,
	faMinus,
	faReply,
	faPlay,
	faPause,
	faMessage,
	faMessageSms,
	faCheck,
	faPaperPlane,
	faUserCheck
} from '@fortawesome/pro-regular-svg-icons';


import {
	faCircleCheck,
	faCircleXmark,
	faGear,
	faEnvelope,
	faCircleInfo,
	faEyeSlash,
	faMapMarkerAlt,
	faUsersGear as faUsersGearSolid
} from '@fortawesome/pro-solid-svg-icons';

library.add(
	faBars,
	faSignOut,
	faPlus,
	faArrowLeft,
	faArrowRight,
	faSearch,
	faCalendarAlt,
	faClone,
	faTimes,
	faEllipsisH,
	faCheckCircle,
	faSpinner,
	faCommentAltDots,
	faLongArrowRight,
	faTrashAlt,
	faPrint,
	faFileInvoice,
	faAngleLeft,
	faAngleRight,
	faCopy,
	faWindows,
	faApple,
	faUpload,
	faHistory,
	faComment,
	faExclamationCircle,
	faCircleCheck,
	faCircleXmark,
	faGear,
	faEnvelope,
	faEdit,
	faAngleUp,
	faAngleDown,
	faEye,
	faPenToSquare,
	faCalendarDays,
	faList,
	faMinus,
	faReply,
	faPlay,
	faPause,
	faMessage,
	faCircleInfo,
	faMessageSms,
	faEyeSlash,
	faMapMarkerAlt,
	faCheck,
	faPaperPlane,
	faUsersGear,
	faUsersGearSolid,
	faUserCheck
);

dom.watch();
